module.exports = __webpack_public_path__ + "static/img/02560_2.bf3f333.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02560_2.jpg
// module id = wcd0
// module chunks = 1